/**
 * 차량선택 모달 (BS)
 */
export default class CarTypeWindow {
    constructor() {
        this.id = null;
        this.parent = null;
        this.data = null;
        this.idx = 0; // 업종 단가표 이미지 인덱스
    }

    getHtml = function(){
        return `
<div id="window-car" class="car">
    <div class="car_wrap">
        <div class="item on sky flex_column" data-value="스카이">
            <div class="flex">
                <img src="/img/order/sky_car.png"
                     srcset="/img/order/sky_car.png 1x,
                             /img/order/sky_car@2x.png 2x,
                             /img/order/sky_car@3x.png 3x,
                             /img/order/sky_car@4x.png 4x"
                     alt="">
            </div>
            <span class="fw_regular">스카이</span>
        </div>
        <div class="item ladder flex_column" data-value="사다리">
            <div class="flex">
                <img src="/img/order/ladder_car.png"
                     srcset="/img/order/ladder_car.png 1x,
                             /img/order/ladder_car@2x.png 2x,
                             /img/order/ladder_car@3x.png 3x,
                             /img/order/ladder_car@4x.png 4x"
                     alt="">
            </div>
            <span class="fw_regular">사다리</span>
        </div>
        <div class="item crane flex_column" data-value="크레인">
            <div class="flex">
                <img src="/img/order/cargo_crain.png"
                     srcset="/img/order/cargo_crain.png 1x,
                             /img/order/cargo_crain@2x.png 2x,
                             /img/order/cargo_crain@3x.png 3x,
                             /img/order/cargo_crain@4x.png 4x"
                     alt="">
            </div>
            <span class="fw_regular">크레인</span>
        </div>
    </div>
    <div class="car_wrap">
        <div class="item forklift flex_column" data-value="지게차">
            <div class="flex">
                <img src="/img/order/fork_lift.png"
                     srcset="/img/order/fork_lift.png 1x,
                             /img/order/fork_lift@2x.png 2x,
                             /img/order/fork_lift@3x.png 3x,
                             /img/order/fork_lift@4x.png 4x"
                     alt="">
            </div>
            <span class="fw_regular">지게차</span>
        </div>
        <div class="item excavator flex_column" data-value="굴삭기">
            <div class="flex">
                <img src="/img/order/excavator.png"
                     srcset="/img/order/excavator.png 1x,
                             /img/order/excavator@2x.png 2x,
                             /img/order/excavator@3x.png 3x,
                             /img/order/excavator@4x.png 4x"
                     alt="">
            </div>
            <span class="fw_regular">굴삭기</span>
        </div>
        <div class="item lift flex_column" data-value="리프트">
            <div class="flex">
                <img src="/img/order/lift.png"
                     srcset="/img/order/lift.png 1x,
                             /img/order/lift@2x.png 2x,
                             /img/order/lift@3x.png 3x,
                             /img/order/lift@4x.png 4x"
                     alt="">
            </div>
            <span class="fw_regular">리프트</span>
        </div>
    </div>
    <div class="table_wrap">
        <h3 class="title" id="cartype-price-title">전국 스카이협회 표준 단가표</h3>
        <div class="prev_btn"></div>
        <div class="price_img"></div>
        <div class="next_btn"></div>
    </div>
</div>`;
    }

    init = function() {
        this.parent.setTitle('장비업종');
        $('#' + this.id).html(this.getHtml());
        this.idx = G5['CARTYPE_KR'].indexOf(this.data['car_type']) + 1;
        this.draw();
        this.initHandler();
    }

    destroy() {
        $('#window-car').off('.cartype');
    }

    drawPrice = function(){
        let imgTag = '';
        let imgTitle = '';
        if( this.idx ){
            const thumb = `/img/table/${this.idx}.png?${G5['cacheVer']}`;// 이미지 변경시마다 숫자를 변경해준다. 캐쉬방지
            const src = `/img/table/${this.idx}.png?${G5['cacheVer']}`; // 이미지 변경시마다 숫자를 변경해준다. 캐쉬방지
            const title = G5['CARTYPE_KR'][this.idx-1];
            imgTag = `<img src="${thumb}" data-src="${src}" loading="lazy" data-title="${title} 단가표" class="js-zoom-img" />`;
            imgTitle = `전국 ${title} 표준 단가표`;
        }

        $('#window-car .table_wrap .price_img').html(imgTag);
        $('#cartype-price-title').html(imgTitle);
    }

    draw = function(){
        const data = this.data;

        $('#window-car .item').removeClass('on');
        $('#window-car .item').each(function(idx,el){
            if( $(el).attr('data-value')==data['car_type'] ){
                $(el).addClass('on');
            }
        });

        // 단가표 이미지
        this.drawPrice();
    }

    initHandler = function(){
        const self = this;
        const $root = $('#window-car');

        $root.off('.cartype');

        $root.on('click.cartype', '.item', function(){
            self.data['car_type'] = $(this).attr('data-value');
            self.apply();
        });

        // 이전 / 다음 단가표 이미지
        $root.on('click.cartype', '.table_wrap .prev_btn', function(){
            self.idx--;
            if(self.idx<1) self.idx=6;
            self.drawPrice();
        });
        $root.on('click.cartype', '.table_wrap .next_btn', function(){
            self.idx++;
            if(self.idx>6) self.idx=1;
            self.drawPrice();
        });

        // 단가표 이미지 클릭 → ZoomPhoto
        $root.on('click.cartype', '.js-zoom-img', function(){
            const src = $(this).data('src') || $(this).attr('src');
            if (src) $j.Ui.ZoomPhoto.open(src);
        });
    }

    apply = function(){
        // close 호출하지 않음 — onApply 가 다음 단계 BS 로 전환(또는 종료) 책임짐
        const cb = this.data?.onApply;
        if (typeof cb === 'function') cb(this.data);
    }
}
